<script>
import Base from '@backend/Base.vue';
import Gen from '@helper/Gen';
import env from './../env';

export default {
    extends: Base,
    data(){
        return {
            Name:"BoDashboard",
            NoSearch: true,

            count_client: '',
            count_client_cp: '',
            count_project: '',
            count_document: '',

            g_years: '',
            g_count_project: '',
            g_count_client: '',
            g_month: '',
            g_out_all_dm: '',
            g_out_all_pc: '',
            g_out_all_sc: '',
            g_y_axis: '',
            g_in_dm: '',
            g_out_dm: '',
            g_inout_dm: '',
            g_in_pc: '',
            g_out_pc: '',
            g_inout_pc: '',
            g_in_sc: '',
            g_out_sc: '',
            g_inout_sc: '',
        }
    },
    mounted(){
        Gen.loadPlugin(env.baseUrl+"/assets/plugins/highcart/highcharts.js")
        this.$set(this.$root, 'page', this);
        this.refreshData();
        setTimeout(()=>{
            Highcharts.chart('container1', {
                title: {
                    text: 'Performance <br> Total clients and project in years'
                },
                xAxis: {
                    categories: Page.g_years,
                    plotBands: [{ // visualize the weekend
                        from: 4.5,
                        to: 6.5,
                    }]
                },
                yAxis: {
                    title: {
                        text: 'Total'
                    }
                },
                legend: {
                    layout: 'vertical',
                    align: 'left',
                    verticalAlign: 'top',
                    x: 100,
                    y: Page.g_y_axis,
                    floating: true,
                    borderWidth: 1,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
                },
                credits: {
                    enabled: false
                },
                series: [{
                    name: 'Project',
                    data: Page.g_count_project
                }, {
                    name: 'Client',
                    data: Page.g_count_client
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            });

            Highcharts.chart('container2', {
                title: {
                    text: 'Total Expenditure'
                },
                xAxis: {
                    categories: Page.g_month,
                    plotBands: [{ // visualize the weekend
                        from: 4.5,
                        to: 6.5,
                    }]
                },
                yAxis: {
                    title: {
                        text: 'Total'
                    }
                },
                legend: {
                    layout: 'vertical',
                    align: 'left',
                    verticalAlign: 'top',
                    x: 100,
                    y: Page.g_y_axis,
                    floating: true,
                    borderWidth: 1,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
                },
                credits: {
                    enabled: false
                },
                series: [{
                    name: 'DM',
                    data: Page.g_out_all_dm
                }, {
                    name: 'PC',
                    data: Page.g_out_all_pc
                }, {
                    name: 'SC',
                    data: Page.g_out_all_sc
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            });

            Highcharts.chart('container3', {
                title: {
                    text: 'Total Activity Duty Meal'
                },
                xAxis: {
                    categories: Page.g_month,
                    plotBands: [{ // visualize the weekend
                        from: 4.5,
                        to: 6.5,
                    }]
                },
                yAxis: {
                    title: {
                        text: 'Total'
                    }
                },
                legend: {
                    layout: 'vertical',
                    align: 'left',
                    verticalAlign: 'top',
                    x: 100,
                    y: Page.g_y_axis,
                    floating: true,
                    borderWidth: 1,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
                },
                credits: {
                    enabled: false
                },
                series: [{
                    name: 'IN',
                    data: Page.g_in_dm
                }, {
                    name: 'OUT',
                    data: Page.g_out_dm
                }, {
                    name: 'IN-OUT',
                    data: Page.g_inout_dm
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            });

            Highcharts.chart('container4', {
                title: {
                    text: 'Total Activity Petty Cash'
                },
                xAxis: {
                    categories: Page.g_month,
                    plotBands: [{ // visualize the weekend
                        from: 4.5,
                        to: 6.5,
                    }]
                },
                yAxis: {
                    title: {
                        text: 'Total'
                    }
                },
                legend: {
                    layout: 'vertical',
                    align: 'left',
                    verticalAlign: 'top',
                    x: 100,
                    y: Page.g_y_axis,
                    floating: true,
                    borderWidth: 1,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
                },
                credits: {
                    enabled: false
                },
                series: [{
                    name: 'IN',
                    data: Page.g_in_pc
                }, {
                    name: 'OUT',
                    data: Page.g_out_pc
                }, {
                    name: 'IN-OUT',
                    data: Page.g_inout_pc
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            });

            Highcharts.chart('container5', {
                title: {
                    text: 'Total Activity Short Cash'
                },
                xAxis: {
                    categories: Page.g_month,
                    plotBands: [{ // visualize the weekend
                        from: 4.5,
                        to: 6.5,
                    }]
                },
                yAxis: {
                    title: {
                        text: 'Total'
                    }
                },
                legend: {
                    layout: 'vertical',
                    align: 'left',
                    verticalAlign: 'top',
                    x: 100,
                    y: Page.g_y_axis,
                    floating: true,
                    borderWidth: 1,
                    backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
                },
                credits: {
                    enabled: false
                },
                series: [{
                    name: 'IN',
                    data: Page.g_in_sc
                }, {
                    name: 'OUT',
                    data: Page.g_out_sc
                }, {
                    name: 'IN-OUT',
                    data: Page.g_inout_sc
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            });
        }, 1000)
    }
}
</script>
<template>
<div class="container-fluid">
<PageTitle></PageTitle>
    <div class="row">
        <div class="col-md-3">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex flex-row">
                        <div class="round align-self-center round-info"><i class="icon-user"></i></div>
                        <div class="m-l-10 align-self-center">
                            <h3 class="m-b-0">{{ count_client }}</h3>
                            <h5 class="text-muted m-b-0">Total Client</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex flex-row">
                        <div class="round align-self-center round-danger"><i class="icon-phone"></i></div>
                        <div class="m-l-10 align-self-center">
                            <h3 class="m-b-0">{{ count_client_cp }}</h3>
                            <h5 class="text-muted m-b-0">Total Contact Person</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex flex-row">
                        <div class="round align-self-center round-purple"><i class="icon-briefcase"></i></div>
                        <div class="m-l-10 align-self-center">
                            <h3 class="m-b-0">{{ count_project }}</h3>
                            <h5 class="text-muted m-b-0">Total Project</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex flex-row">
                        <div class="round align-self-center round-danger"><i class="icon-docs"></i></div>
                        <div class="m-l-10 align-self-center">
                            <h3 class="m-b-0">{{ count_document }}</h3>
                            <h5 class="text-muted m-b-0">Total Documents</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div id="container1"></div>
        </div>
    </div>
    <div class="row m_top_20">
        <div class="col-md-12">
            <div id="container2"></div>
        </div>
    </div>
    <div class="row m_top_20">
        <div class="col-md-12">
            <div id="container3"></div>
        </div>
    </div>
    <div class="row m_top_20">
        <div class="col-md-12">
            <div id="container4"></div>
        </div>
    </div>
    <div class="row m_top_20">
        <div class="col-md-12">
            <div id="container5"></div>
        </div>
    </div>
</div>
</template>